import { IndicatorTag, Intent } from '@pinpointhq/thumbtack';
import * as React from 'react';

export function IndicatorTagCell({ count }: { count: number }) {
  return (
    <div>
      <IndicatorTag intent={Intent.SUCCESS}>{count}</IndicatorTag>
    </div>
  );
}
